<template>
  <div class="page-index scan-code-index">
    <div class="toolbar-box">
      <!-- <el-button class="btn-left" size="mini" @click="openModel">添加字段</el-button> -->
      <!-- <div style="flex:1"></div> -->
      <el-select v-if="userInfo.companyList.length > 0" v-model="companyId" @change="seach" placeholder="请选择公司">
        <el-option v-for="item in userInfo.companyList" :key="item.id" :label="item.name" :value="item.id"></el-option>
      </el-select>
      <div style="color:red;line-height:36px;margin-left:10px;">注：双击已选择字段可以修改字段显示名称</div>
    </div>
    <div class="title-box">
      <div class="title-box-item">系统字段</div>
      <div class="title-box-item">
        <span>已选择字段</span>
        <el-button class="btn-sub" size="mini" @click="hanleSub">保存</el-button>
      </div>
      <div class="title-box-item">页面预览</div>
    </div>
    <div class="main-box">
      <draggable class="manipulate-box" :list="list" group="field" :animation='200'>
        <transition-group :style="{height: tableHeight + 'px', display: 'inline-block', width: '100%'}">
          <div class="draggable-item" v-for="item in list" :key="item.value">
            <span>{{item.original}}</span>
          </div>
        </transition-group>
      </draggable>
      <draggable class="manipulate-box" :list="list2" group="field" :animation='200'>
        <transition-group :style="{height: tableHeight + 'px', display: 'inline-block', width: '100%'}">
          <div @dblclick="showInput(item, index)" class="draggable-item" v-for="(item, index) in list2" :key="item.value">
            <span v-show="item.show">{{item.name == item.original ? item.name : `${item.name}（${item.original}）`}}</span>
            <el-input ref="input" v-show="!item.show" v-model="list2[index].name" placeholder="请输入内容" @blur="onInputBlur(index)"></el-input>
          </div>
        </transition-group>
      </draggable>
      <div class="preview-box" :style="{height: tableHeight + 'px'}">
        <el-form>
          <el-form-item class="param-box" v-for="item in list2" :key="item.value" :label="item.name">
            <div class="text-right">{{item.value}}</div>
          </el-form-item>
        </el-form>
      </div>
      <div class="clear"></div>
    </div>

    <el-dialog
        title="添加字段"
        :visible.sync="dialogVisible"
        width="550px">
      <el-form ref="organization" :model="form" label-width="180px">
        <el-form-item label="字段名称">
          <el-input placeholder="请输入字段名称" v-model="form.name"></el-input>
        </el-form-item>
        <el-form-item label="公司" prop="companyId">
          <el-select v-model="form.companyId" placeholder="请选择公司">
            <el-option v-for="item in userInfo.companyList" :key="item.id" :label="item.name" :value="item.id"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="hanleSub">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script type="text/ecmascript-6">
  import { tableMixin } from '../../mixins/table'
  import { mapGetters } from 'vuex'
  import { formatDate } from '../../utils/common'
  import draggable from 'vuedraggable'
  import { apiEdit, apiList, apiList2 } from '../../api/labelField'

  export default {
    mixins: [tableMixin],
    name: 'scan-code',
    data() {
      return {
        dialogVisible: false,
        list: [],
        list2: [],
        pageIndex: 1,
        total: 0,
        companyId: '',
        form: {}
      }
    },
    computed: {
      ...mapGetters([
        'userInfo',
        'roles',
        'currentRoles'
      ])
    },
    created() {
      if (this.userInfo.companyList) {
        this.companyId = this.userInfo.companyList[0].id
        this._getList()
      }
    },
    methods: {
      // 打开model
      openModel() {
        this.dialogVisible = true
      },
      // 翻页
      pageChange(pageIndex) {
        this.pageIndex = pageIndex
        this._getList(pageIndex)
      },
      // 搜索
      seach() {
        this.pageIndex = 1
        this._getList()
      },
      onInputBlur(index) {
        this.list2[index].show = true
      },
      showInput(row, index) {
        this.list2[index].show = false
        let ref = 'input' + index
        this.$nextTick(() => {
          this.$refs['input'][index].focus()
        })
      },
      // 获取列表
      _getList() {
        apiList(this.companyId).then(data => {
          this.list = []
          data.data.forEach(item => {
            this.list.push({
              name: item.name,
              original: item.name,
              value: item.value,
              show: true
            })
          })
          apiList2(this.companyId).then(data2 => {
            this.list2 = []
            data2.data.forEach(item => {
              this.list2.push({
                name: item.name,
                original: item.name,
                value: item.field,
                show: true
              })
            })
            this.list = this.array_diff(this.list, this.list2)
          })
        })
      },
      // 保存
      hanleSub() {
        let field = []
        this.list2.forEach((item, index) => {
          field.push({
            name: item.name,
            companyId: this.companyId,
            field: item.value,
            sort: index
          })
        })
        apiEdit(field).then(() => {
          this.$message({
            type: 'success',
            message: '保存成功'
          })
        })
      },
      // 修改
      hanleEdit() {},
      // 数组去重
      array_diff(a, b) {
        for (var i = 0; i < b.length; i++) {
          for (var j = 0; j < a.length; j++) {
            if (a[j].value === b[i].value) {
              a.splice(j, 1)
              j = j - 1
            }
          }
        }
        return a
      }
    },
    components: {
      draggable
    }
  }
</script>

<style lang="stylus">
  .page-index.scan-code-index
    .btn-sub
      float right
      margin-bottom 5px
      background #3289d3
      color #fff
    .btn-left
      background #A5CE1C
      color #fff
    .toolbar-box
      display flex
      margin 10px 0
      .search-input
        width 150px
    .main-box
      display flex
      width 100%
      .manipulate-box
        margin-right 15px
        .draggable-item
          position relative
          display block
          padding 10px 15px
          // margin-bottom -1px
          background #F3F7FA
          border-bottom 1px solid #D9E7F4
          cursor move
          user-select none
          color #66B0F1
        .draggable-item:first-child
          border-top-left-radius 4px
          border-top-right-radius 4px
      .preview-box
        overflow-y auto
        user-select none
        .param-box
          padding 10px 30px
          margin 0
          border-bottom 1px solid #EFEFEF
          .el-form-item__label
            font-size 18px
          .text-right
            text-align right
            font-size  16px
      .manipulate-box, .preview-box
        float left
        width calc((100% - 30px) / 3)
        background #F3F7FA
      .clear
        clear both
    .title-box
      display flex
      font-size 16px
      height 25px
      font-weight bold
      color #252525
      margin-bottom 10px
      .title-box-item
        float left
        margin-right 15px
        width calc((100% - 30px) / 3)
      .title-box-item:last-child
        margin-right 0
</style>
